export default __webpack_public_path__ + "static/media/README.1b9811d1.md";